<template>
    <div class="content-wrapper pl-3 pr-3 pb-3 pt-3 mb-2" style="height: inherit; width:inherit;">
        <!-- Content Header (Page header) -->
        <!-- <div v-if="$gate.isBranchManager()"> -->
        <!-- Whatever VUE CONTENT: PLACE IT AFTER THIS COMMENT -->

        <section class="content-header">
            <div class="container-fluid">
                <div class="row mb-2">
                    <div class="col-sm-6">
                        <h2>{{ $route.meta.title }}</h2>
                    </div>
                    <div class="col-sm-6">
                        <ol class="breadcrumb float-sm-right">
                            <li class="breadcrumb-item"><a href="/home">Home</a></li>
                            <li class="breadcrumb-item active">{{ $route.meta.title }}</li>
                        </ol>
                    </div>
                </div>
            </div><!-- /.container-fluid -->
        </section>

        <!-- Main content -->
        <section class="content">
            <br>
            <div class="col-lg-12">
                <div class="card card-danger card-outline collapsed-card">
                    <div class="card-header">
                        <div class="card-title">Data Filters</div>
                        <div class="card-tools">
                                <!-- Collapse Button -->
                                <button class="btn btn-secondary" @click="getDeliveryStatusReport('/api/generateDeliveryStatusReport')"><i class="fa fa-refresh"></i> Refresh</button>
                                &nbsp;
                                <button class="btn btn-secondary" @click="copyTable"><i class="fas fa-copy"></i> Copy Table</button>
                                &nbsp;
                                <button type="button" class="btn btn-tool btn-danger" data-card-widget="collapse"><i class="fas fa-minus"></i> Show/Hide</button>
                        </div>
                    </div>
                    <div class="card-body">
                        <div class="col-lg-12 float-left">
                            <div class="row">

                                <!-- <div class="col-sm-4" v-if='$gate.isZonalManager()'> -->

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Created From:</span>
                                        <input type="date" class="form-control" v-model="params.from_date" placeholder="From date">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Created Till:</span>
                                        <input type="date" class="form-control" v-model="params.to_date" placeholder="To date">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Confirmed Delivery Date:</span>
                                        <input type="date" class="form-control" v-model="params.confirmed_delivery_date" placeholder="Confirmed Delivery date">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Preferred Delivery Date:</span>
                                        <input type="date" class="form-control" v-model="params.preferred_delivery_date" placeholder="Preferred Delivery date">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Pick Status:</span>
                                        <select v-model="params.delivery_status" style="width: 100% !important" class="form-control">
                                            <option v-for="j in delivery_statuses" :key="j.id" :value="j.status">
                                                {{ j.status}}
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Status Updated On:</span>
                                        <input type="date" class="form-control" v-model="params.status_updated_on" placeholder="Preferred Delivery date">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Search in Status Notes:</span>
                                        <input type="text" class="form-control" v-model="params.status_notes" placeholder="Search Status ">
                                    </div>
                                </div>
                                <div class="col-sm-4" v-if='$gate.isWarehouseManager()==true || $gate.isServiceAdmin()==true || $gate.isHRAdmin()==true  || $gate.isOnlineSalesManager()==true || $gate.isOnlineSalesAssociate()==true || $gate.isCCManager()==true || $gate.isCCAgent()==true  || $gate.isServiceManager()==true || $gate.isZonalManager()==true || $gate.isMISAdmin()==true || $gate.isSecondaryMISAdmin()==true || $gate.isPurchaseAdmin()==true || $gate.isPurchaseManager()==true || $gate.isSecondaryPurchaseAdmin()==true || $gate.isSecondaryPurchaseManager()==true'>
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Selling Branch:</span>
                                        <select class="form-control" v-model="params.branch" @change="getLinkedBranches">
                                            <option v-for="branch in branches" :value="branch.branch_code">{{branch.branch}}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <!--                        <div class="col-sm-4" v-if='$gate.isWarehouseManager()==true || $gate.isServiceAdmin()==true  || $gate.isServiceManager()==true || $gate.isZonalManager()==true || $gate.isMISAdmin()==true || $gate.isSecondaryMISAdmin()==true'>-->
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Stock Origin:</span>
                                        <select class="form-control" v-model="params.serving_branch">
                                            <option v-for="branch in linked_branches" :value="branch.inventory_source">{{branch.inventory_source}}</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Delivery Route:</span>
                                        <select v-model="params.delivery_route" style="width: 100% !important" class="form-control">
                                            <option v-for="j in delivery_routes" :key="j.id" :value="j.id">
                                                {{ j.branch }}, {{ j.route }}
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Item Category:</span>
                                        <select v-model="params.delivery_item_category" style="width: 100% !important" class="form-control">
                                            <option v-for="j in delivery_item_categories" :key="j.id" :value="j.id">
                                                {{ j.category }}
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Combo:</span>
                                        <select v-model="params.is_combo" style="width: 100% !important" class="form-control">
                                            <option value="0">
                                                No
                                            </option>
                                            <option value="1">
                                                Yes
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">DC Done:</span>
                                        <select v-model="params.is_billed" style="width: 100% !important" class="form-control">
                                            <option value="0">
                                                No
                                            </option>
                                            <option value="1">
                                                Yes
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Invoice Done:</span>
                                        <select v-model="params.is_invoiced" style="width: 100% !important" class="form-control">
                                            <option value="0">
                                                No
                                            </option>
                                            <option value="1">
                                                Yes
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Summary:</span>
                                        <select v-model="params.summary" style="width: 100% !important" class="form-control">
                                            <option value="0">
                                                Pending
                                            </option>
                                            <option value="2">
                                                Cancelled
                                            </option>
                                            <option value="1">
                                                Completed
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Urgent:</span>
                                        <select v-model="params.is_urgent" style="width: 100% !important" class="form-control">
                                            <option value="0">
                                                No
                                            </option>
                                            <option value="1">
                                                Yes
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">GST BILL REQUIRED:</span>
                                        <select v-model="params.gst_bill_required" style="width: 100% !important" class="form-control">
                                            <option value="0">
                                                No
                                            </option>
                                            <option value="1">
                                                Yes
                                            </option>
                                            <!-- <span v-if="errors.delivery_route" :class="['badge bg-danger']">Please choose a route from route master</span> -->
                                        </select>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Gatepass No:</span>
                                        <input class="form-control" placeholder="Enter gatepass" v-model="params.gatepass_no" type="text">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Customer Name:</span>
                                        <input class="form-control" placeholder="Enter customer name" v-model="params.customer_name" type="text">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Phone Number:</span>
                                        <input class="form-control" placeholder="Enter phone number" v-model="params.phone_number" type="number" min="1">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <span class="right badge badge-secondary">Item Code:</span>
                                        <input class="form-control" placeholder="Enter itemcode" v-model="params.item_code" type="text" min="1">
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <span class="right badge badge-secondary">POS ID:</span>
                                    <div class="form-group"><input class="form-control" placeholder="Enter delivery commitment id" v-model="params.dc_id" type="number" min="1">
                                    </div>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button class="btn btn-primary" style="width:100% !important;" @click="getDeliveryStatusReport('/api/generateDeliveryStatusReport')">Search</button>
                                    </div>
                                </div>
                                <div class="col-sm-4">
                                    <div class="form-group">
                                        <button class="btn btn-danger" style="width:100% !important;" @click="reset">Reset</button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            Displaying Results with filters: From {{this.params.from_date}} to {{this.params.to_date}} for branches {{params.branch}}
            <br>
            <br>
            <div class="10">
                <div class="row">
                    <div class="col-md-11">
                        <div class="row" align="center">
                            <div class="col-lg-3 col-12">
                                <!-- small box -->
                                <div class="small-box bg-danger">
                                    <div class="inner">
                                        <h4>{{ getTotalCount }}</h4>
                                        <p>Total Commitments</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-person-add"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-3 col-12" v-if="$gate.isMISAdmin() || $gate.isSecondaryMISAdmin()|| $gate.isWarehouseManager() || $gate.isStoreManager() || $gate.isBranchManager() || $gate.isBranchAccountant()">
                                <!-- small box -->
                                <div class="small-box bg-danger">
                                    <div class="inner">
                                        <h4>{{dc_total | dotNumbers}}</h4>
                                        <p>Total Value</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-pie-graph"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-3 col-12" v-if="$gate.isMISAdmin() || $gate.isSecondaryMISAdmin() || $gate.isWarehouseManager() || $gate.isStoreManager() || $gate.isBranchManager() || $gate.isBranchAccountant()">
                                <!-- small box -->
                                <div class="small-box bg-orange">
                                    <div class="inner">
                                        <h4>{{dc_pending | dotNumbers}}</h4>
                                        <p>Pending Amount</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-bag"></i>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-3 col-12" v-if="$gate.isMISAdmin() || $gate.isSecondaryMISAdmin() || $gate.isWarehouseManager() || $gate.isStoreManager() || $gate.isBranchManager() || $gate.isBranchAccountant()">
                                <!-- small box -->
                                <div class="small-box bg-success">
                                    <div class="inner">
                                        <h4>{{dc_collected | dotNumbers}}</h4>
                                        <p>Collected Amount</p>
                                    </div>
                                    <div class="icon">
                                        <i class="ion ion-bag"></i>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <br>
            <div class="col-lg-12">
                <div class="card">
                    <div class="card-body table-responsive">
                        <div v-if="show_value==1" class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" :id="show_value" checked @input="toggleValueVisibility">
                            <label class="custom-control-label" :for="show_value">Showing Value</label>
                        </div>
                        <div v-if="show_value==0" class="custom-control custom-switch">
                            <input type="checkbox" class="custom-control-input" :id="show_value" checked @input="toggleValueVisibility">
                            <label class="custom-control-label" :for="show_value">Not Showing Values</label>
                        </div>
                        <br><br>
                        <table class="table table-hover table-striped table-bordered overflow-auto">
                            <thead class="thead-light sticky-top top-0" style="position: sticky !important; top: 0 !important;">
                            <tr>
                                <th>Selling Branch</th>
                                <th>Stock Origin</th>
                                <th v-for="gp in delivery_statuses" style="cursor: pointer" :key="gp.status" @click="toggleSortOrder(gp.status)">{{ gp.status }} <i
                                    v-if="sortBy === gp.status"
                                    :class="[sortAscending ? 'fa fa-caret-up' : 'fa fa-caret-down']"
                                ></i></th>
                                <th>Total Count</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="(group, index) in groupedData" :key="index">
                                <td>{{ group.branch_code }}</td>
                                <td>{{ group.linked_warehouse }}</td>
                                <td v-for="gp in delivery_statuses" :key="gp.status">{{ getStatusCount(group, gp.status) }} <p v-if="show_value==1">({{ group.sum_values[gp.status]}})</p></td>
                                <td>{{ group.total_count }} <span v-if="show_value==1">({{ group.total_sum_value|dotNumbers }})</span></td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <th></th>
                                <th>Total</th>
                                <th v-for="gp in delivery_statuses" :key="gp.status">
                                    {{ getColumnTotal(gp.status, 'counts') }}
                                    <p v-if="show_value == 1"> ({{ getColumnTotal(gp.status, 'sum_values')|dotNumbers}})</p>
                                </th>
                                <th>{{ getTotalCount }} <p v-if="show_value == 1"> ({{ getTotalValue|dotNumbers }})</p></th>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                    <div class="card-footer">

                    </div>
                </div>
            </div>
        </section>
        <!-- /.content -->


        <loading
            :show="lshow"
            :label="llabel">
        </loading>
        <!-- All VUE Parts end before this comment -->
        <!-- </div>
        <div v-if="!$gate.isBranchManager()">
             <access-denied></access-denied>
        </div> -->
    </div>
</template>

<script>
import { parse } from "postcss";
import Pagination from "../../pagination.vue";
import loading from 'vue-full-loading';
export default {
    mounted() {
        console.log("Component mounted.");
    },

    components: {loading: loading, pagination: Pagination },

    created(){
        var today = new Date();
        // var dd = today.getDate();
        // var mm = today.getMonth()+1;
        // var yyyy = today.getFullYear();
        // this.today_date = yyyy+'-'+mm+'-'+dd;
        const currentDate = new Date();
        const year = currentDate.getUTCFullYear();
        const month = (currentDate.getUTCMonth() + 1).toString().padStart(2, '0');
        const day = (currentDate.getUTCDate()-1).toString().padStart(2, '0');
        const hours = currentDate.getUTCHours().toString().padStart(2, '0');
        const minutes = currentDate.getUTCMinutes().toString().padStart(2, '0');
        const seconds = currentDate.getUTCSeconds().toString().padStart(2, '0');

        this.today_date = `${year}-${month}-${day}T00:00:00.000000Z`;
        console.log(this.today_date);
        this.getDeliveryRoutes();
        this.getDeliveryItemCategories();
        this.getDeliveryStatusList();
        this.getBranches();
        this.usertype = window.user.user_type;
        if(this.usertype=='mis-admin' || this.usertype=='secondary-mis-admin' || this.usertype=='cc-manager' || this.usertype=='hr-admin'|| this.usertype=='online-sales-manager'|| this.usertype=='online-sales-associate' || this.usertype=='cc-agent' || this.usertype=='service-admin' || this.usertype=='purchase-admin' || this.usertype=='purchase-manager' || this.usertype=='secondary-purchase-admin' || this.usertype=='secondary-purchase-manager') {
            this.params.branch = '';
        }
        else if(this.usertype=='warehouse-manager' || this.usertype=='store-manager') {
            this.params.branch = '';
            this.params.serving_branch=window.user.branch;
        }
        else{
            this.params.branch=window.user.branch;
            this.getLinkedBranches();
        }
        this.params.from_date= new Date().toISOString().slice(0, 10);
        this.params.to_date= new Date().toISOString().slice(0, 10);
        this.getDeliveryStatusReport();
    },

    data(){
        return {
            lshow: false,
            llabel: 'Updating Leads. Do not close or change this page...',
            status_report:[],
            delivery_statuses:[],
            linked_branches:[],
            delivery_item_categories:[],
            delivery_routes:[],
            branches:[],
            medias:[],
            reasons:[],
            show_value:1,
            sortBy: 'Converted',
            sortAscending: false,
            collected_amount: '',
            dc_total: '',
            dc_pending: '',
            dc_collected: '',
            interval: null,
            params: new Form({
                from_date: null,
                to_date: null,
                confirmed_delivery_date: null,
                preferred_delivery_date: null,
                delivery_status: null,
                status_updated_on:null,
                status_notes:null,
                delivery_route: null,
                delivery_item_category: null,
                phone_number: null,
                gatepass_no: null,
                customer_name: null,
                item_code: null,
                dc_id: null,
                is_combo: null,
                is_urgent: null,
                is_billed: null,
                is_invoiced: null,
                summary: null,
                serving_branch:[],
                branch:[],
                gst_bill_required: null
            }),
        }
    },

    computed: {
        groupedData() {
            const grouped = [];
            const groupKeyMap = new Map();

            this.status_report.forEach((item) => {
                const branchCode = item.branch_code;
                const linkedWarehouse = item.linked_warehouse;
                const warehouseKey = `${branchCode}_${linkedWarehouse}`;
                const status = item.status;
                const count = item.count;
                const sumValue = item.sum_value;

                if (!groupKeyMap.has(warehouseKey)) {
                    groupKeyMap.set(warehouseKey, grouped.length);
                    grouped.push({
                        branch_code: branchCode,
                        linked_warehouse: linkedWarehouse,
                        counts: {},
                        sum_values: {} // Initialize sum_values object
                    });
                }

                const groupIndex = groupKeyMap.get(warehouseKey);
                if (!grouped[groupIndex].counts[status]) {
                    grouped[groupIndex].counts[status] = 0;
                    grouped[groupIndex].sum_values[status] = 0; // Initialize sum_value for status
                }
                grouped[groupIndex].counts[status] += count;
                grouped[groupIndex].sum_values[status] += sumValue; // Accumulate weighted sum_value
            });

            // Calculate total_count and total_sum_value for each group
            grouped.forEach((group) => {
                group.total_count = Object.values(group.counts).reduce((sum, count) => sum + count, 0);
                group.total_sum_value = Object.values(group.sum_values).reduce((sum, value) => sum + value, 0);
            });

            // Sort the grouped array by the count of 'Converted' status in descending order
            const sortedGrouped = [...grouped];
            sortedGrouped.sort((a, b) => {
                const aValue = a.counts[this.sortBy] || 0;
                const bValue = b.counts[this.sortBy] || 0;
                return this.sortAscending ? aValue - bValue : bValue - aValue;
            });

            return sortedGrouped;
        },
        // Calculate the total count for all groups
        getTotalCount() {
            return this.groupedData.reduce((sum, group) => sum + group.total_count, 0);
        },
        getTotalValue() {
            return this.groupedData.reduce((sum, group) => sum + group.total_sum_value, 0);
        },
    },

    methods: {
        reset(){
            this.params.reset();
            this.getDeliveryStatusReport();
        },

        toggleSortOrder(status) {
            if (this.sortBy === status) {
                this.sortAscending = !this.sortAscending;
            } else {
                this.sortBy = status;
                this.sortAscending = false;
            }
        },

        copyTable() {
            const table = document.querySelector('.table'); // Select the table element using its class
            const range = document.createRange();
            range.selectNode(table);
            const selection = window.getSelection();
            selection.removeAllRanges();
            selection.addRange(range);
            document.execCommand('copy');
            selection.removeAllRanges();

            alert('Table content copied to clipboard!');
        },

        getBranches(){
            if(this.usertype == 'zonal-manager'){
                axios.post("/api/getZonalManagerBranches")
                    .then(response => {
                        this.branches = response.data;
                    });
            }
            else{
                axios.post("/api/getSAPBranches")
                    .then(response => {
                        this.branches = response.data;
                    })
            }
        },
        getLinkedBranches(){
            axios.post("/api/getLinkedBranches",{ branch: this.params.branch })
                .then(response => {
                    this.linked_branches = response.data.data;
                });
        },


        getDeliveryRoutes() {
            axios.post("/api/getDeliveryRoutes").then(response => {
                this.delivery_routes = response.data;
            });
        },

        getDeliveryStatusList() {
            axios.post("/api/getDeliveryStatusList").then(response => {
                this.delivery_statuses = response.data;
            });
        },

        getDeliveryItemCategories() {
            axios.post("/api/getDeliveryItemCategories").then(response => {
                this.delivery_item_categories = response.data;
            });
        },

        getStatusCount(group, status) {
            return group.counts[status] || 0;
        },

        toggleValueVisibility(){
          if(this.show_value==0)
              this.show_value=1;
          else
              this.show_value=0;
        },

        getDeliveryStatusReport(url = "/api/generateDeliveryStatusReport") {
            axios.post(url, { filters: this.params }).then((response) => {
                this.status_report = response.data.report;
                this.dc_total = response.data.total_amount;
                this.dc_pending= response.data.pending_amount;
                this.dc_collected = response.data.collected_amount;
                // this.configPagination(response.data.data);
            });
        },

        // Calculate the column-wise total for a specific status
        // getColumnTotal(status) {
        //     return this.groupedData.reduce((sum, group) => sum + (group.counts[status] || 0), 0);
        // },
        getColumnTotal(status, property) {
            return this.groupedData.reduce((total, group) => {
                return total + (group[property][status] || 0);
            }, 0);
        },


    }
}
</script>
